export const searchSetting = {
	A_KEYWORD: 'APPLY_KEY_WORD',
	S_KEYWORD: 'SAVE_KEYWORD',
	GET_DATE: 'GET_DATE',
	A_MEDIA: 'APPLY_MEDIA',
	A_NOT_MEDIA: 'APPLY_NOT_MEDIA',
	A_MEDIA_CLEAN: 'APPLY_MEDIA_CLEAN_DATA',
	A_NOT_MEDIA_CLEAN: 'APPLY_NOT_MEDIA_CLEAN_DATA',
	A_TYPE: 'APPLY_TYPE',
	A_CHKEY: 'APPLY_CH_KEY',
	FILTER_ACTION: 'FILTER_ACTION',
	SEARCH_METHOD: 'SEARCH_METHOD',
	REQUEST_KEYWORD: 'RESQUEST_MY_KEYWORD',
	RECEIVE_KEYWORD: 'RECEIVE_MY_KEYWORD',
	REQUEST_MYHISTORYLOG:'REQUEST_MY_HISTORYLOG',
	RECEIVE_MYHISTORYLOG:'RECEIVE_MY_HISTORYLOG',
	APPLY_AUTHOR: 'APPLY_AUTHOR',
	APPLY_NOT_AUTHOR: 'APPLY_NOT_AUTHOR',
	APPLY_DOC: 'APPLY_DOC',
	APPLY_NOT_DOC: 'APPLY_NOT_DOC',
	APPLY_DOC_TAG: 'APPLY_DOC_TAG',
	APPLY_NOT_DOC_TAG: 'APPLY_NOT_DOC_TAG',
	REMOVE_FILTER: 'REMOVE_FILTER',
	REQUEST_MYAUTHOR: 'REQUEST_MYAUTHOR',
	RECEIVE_MYAUTHOR: 'RECEIVE_MYAUTHOR',
	SELECT_AUTHOR: 'SELECT_AUTHOR',
	REQUEST_MYDOC: 'REQUEST_MYDOC',
	RECEIVE_MYDOC: 'RECEIVE_MYDOC',
	SELECT_DOC: 'SELECT_DOC',
	A_MEDIA_FROM_ARTICLE: 'A_MEDIA_FROM_ARTICLE',
	A_NOT_MEDIA_FROM_ARTICLE: 'A_NOT_MEDIA_FROM_ARTICLE',
	REQUEST_MYWIDGETS: 'REQUEST_MYWIDGETS',
	RECEIVE_MYWIDGETS: 'RECEIVE_MYWIDGETS',
	REQUEST_MYMEDIA: 'REQUEST_MYMEDIA',
	RECEIVE_MYMEDIA: 'RECEIVE_MYMEDIA',
	SELECT_MYMEDIA: 'SELECT_MYMEDIA',
	REQUEST_MYALERTS: 'REQUEST_MYALERTS',
	RECEIVE_MYALERTS: 'RECEIVE_MYALERTS',
	CHANGE_SELECT_ALERT_ID: 'CHANGE_SELECT_ALERT_ID',
	REQUEST_MYDIFFS: 'REQUEST_MYDIFFS',
	RECEIVE_MYDIFFS: 'RECEIVE_MYDIFFS',
	CLEAN_ALL: 'CLEAN_ALL_CONDITION',
	REMOVE_TYPE:'REMOVE_TYPE',
	SET_TIME_STATUS: 'T_STATUS',
	APPLY_NOT_AG:"APPLY_NOT_AUTHOR_GROUP",
	APPLY_AG:"APPLY_AUTHOR_GROUP",
	APPLY_NOT_DG:'APPLY_NOT_DOCUMENT_GRIUP',
	APPLY_DG:'APPLY_DOCUMENT_GRIUP',
	APPLY_NOT_SG:'APPLY_NOT_SOURCE_GROUP',
	APPLY_SG:'APPLY_SOURCE_GROUP',
	REMOVE_GROUP_FILTER : "REMOVE_GROUP_FILTER",

	// SET_MY_DIFFUSION:'SET_MY_DIFFUSION',
	RECEIVE_MY_DIFFUSION_SET:'RECEIVE_MY_DIFFUSION_SET',

	RECEIVE_KEYWORD_COLOR:'RECEIVE_MAIN_KEYWORD_COLOR',

	REQUEST_FETCH_API:'REQUEST_FETCH_PROCESS',
	RECEIVE_FETCH_API:'RECEIVE_FETCH_API_DATA'
};



// WEBPACK FOOTER //
// ./src/constants/search.constants.js